export const ROLE_SUPER_ADMIN = 'SUPER_ADMIN';
export const ROLE_TENANT_ADMIN = 'TENANT_ADMIN';
export const ROLE_TENANT_TECHNICIAN_COORDINATOR = 'TECHNICIAN_COORDINATOR';
export const ROLE_TENANT_TECHNICIAN = 'TECHNICIAN';
export const ROLE_TENANT_OPERATOR = 'OPERATOR';
export const ROLE_TENANT_DIRECTOR = 'DIRECTOR';
export const ROLE_TENANT_SUPPLIER = 'SUPPLIER';

export const SuperAdminRoles = [ROLE_SUPER_ADMIN];
export const TenantAdminRoles = [ROLE_TENANT_ADMIN, ROLE_SUPER_ADMIN];

export const BottomFromTechnicianCoordinatorRoles = [
  ROLE_TENANT_TECHNICIAN_COORDINATOR,
  ROLE_TENANT_ADMIN,
  ROLE_SUPER_ADMIN
];

export const BottomFromTechnicianRoles = [
  ROLE_TENANT_TECHNICIAN,
  ROLE_TENANT_TECHNICIAN_COORDINATOR,
  ROLE_TENANT_ADMIN,
  ROLE_SUPER_ADMIN
];

export const BottomFromOperatorRoles = [
  ROLE_TENANT_OPERATOR,
  ROLE_TENANT_TECHNICIAN,
  ROLE_TENANT_TECHNICIAN_COORDINATOR,
  ROLE_TENANT_ADMIN,
  ROLE_SUPER_ADMIN
];

export const BottomFromDirectorRoles = [
  ROLE_TENANT_DIRECTOR,
  ROLE_TENANT_OPERATOR,
  ROLE_TENANT_TECHNICIAN,
  ROLE_TENANT_TECHNICIAN_COORDINATOR,
  ROLE_TENANT_ADMIN,
  ROLE_SUPER_ADMIN
];

//SOSTITUIRE
export const NotOperatorRoles = [
  ROLE_SUPER_ADMIN,
  ROLE_TENANT_ADMIN,
  ROLE_TENANT_TECHNICIAN_COORDINATOR,
  ROLE_TENANT_TECHNICIAN
];
export const TenantRoles = [
  ROLE_TENANT_ADMIN,
  ROLE_TENANT_TECHNICIAN_COORDINATOR,
  ROLE_TENANT_DIRECTOR,
  ROLE_TENANT_SUPPLIER,
  ROLE_TENANT_TECHNICIAN,
  ROLE_TENANT_OPERATOR
];
